// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadFAQ_container__3-tMv","uploadFAQ":"UploadFAQ_uploadFAQ__15SLc"};